<template>
  <div class="serviceConfig">
    <div class="page_title">客服电话配置</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container"
           style="padding: 20px;">
        <div v-for="(item,index) in serviceData"
             :key="index"
             class="serviceConfig-box">
          <p class="title">{{ item.desc }}</p>
          <el-input v-model="item.value"
                    clearable></el-input>
          <el-button type="primary"
                     size="small"
                     :disabled=" module_id_array[0] ? !module_id_array.includes('750') : false"
                     @click="save(item)">保存</el-button>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import common from '../../../api/common';

export default {
  data() {
    return {
      serviceData: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array || [];
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      if (this.module_id_array[0] && !this.module_id_array.includes('749')) {
        return;
      }
      common.getContactConfigList().then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.serviceData = data.list;
        }
      });
    },

    save(data) {
      let params = {
        key: data.key,
        value: data.value
      };
      common.updateContactConfig(params).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success('保存成功');
        }
      });
    },
    close() {}
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.serviceConfig-box {
  display: flex;
  align-items: center;
  .title {
    width: 160px;
    text-align: left;
  }
  .el-input {
    width: 400px;
  }
  .el-button {
    margin-left: 20px;
  }
}
</style>